<script>
import axios from "axios";

const name = '火焰云加速器'
const homeLink = 'https://www.hongxiaodou.top/'
const docsLink = 'https://docs.hongxiaodou.top'
var email = ''
var qq = ''
var pagefooter = ''
const linkStr = 'hongxiaodou.top:20033'
const footerLinkStr = 'hongxiaodou.top'
const requestLink = 'hongxiaodou.top'
// const apibaseURL = 'http://47.242.52.110/api'
const apibaseURL = 'https://www.hongxiaodou.top/api'
const beian = '鄂ICP备2023016192号-1';
const downHost = 'https://hongxiaodou.top';
const paymode = 4;

// const name = '轻洽云'
// const homeLink = 'http://www.qingqia.net/'
// var email = '153888343@qq.com'
// var qq = '153888343'
// var pagefooter = ''
// const linkStr = 'vpn.qingqia.net:50033'
// const footerLinkStr = 'vpna.qingqia.net'
// const requestLink = 'vpn.qingqia.net'
// const apibaseURL = 'https://vpn.qingqia.net/api'
// const beian ='';
// const downHost = 'https://down.qingiqa.net';
// const paymode = 2;

const configjson = {
  headers: {
    'content-type': 'application/json',
  }
};
const configform = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  }
};

// function getOs() {
//   let browser = {
//     versions: function () {
//       let u = navigator.userAgent
//       return {         //移动终端浏览器版本信息
//         trident: u.indexOf('Trident') > -1, //IE内核
//         presto: u.indexOf('Presto') > -1, //opera内核
//         webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
//         gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
//         mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
//         ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
//         android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
//         iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
//         iPad: u.indexOf('iPad') > -1, //是否iPad
//         webApp: u.indexOf('Safari') == -1//是否web应该程序，没有头部与底部
//       }
//     }(),
//     language: (navigator.browserLanguage || navigator.language).toLowerCase()
//   }
//   if (browser.versions.android) {
//     return `mqq://card/show_pslcard?src_type=internal&version=1&uin=${qq}&card_type=person&source=sharecard`
//   } else if (browser.versions.ios) {
//     return `mqq://card/show_pslcard?src_type=internal&version=1&uin=${qq}&card_type=person&source=sharecard`
//   } else {
//     return `tencent://AddContact/?fromId=45&fromSubId=1&subcmd=all&uin=${qq}`
//   }
//
// }

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = apibaseURL;
async function getSetting() {
  try {
    const resp = await axios.get('/other/get');
    let rdata = resp.data;
    if (rdata.code === 0) {
      qq = rdata.data.qq;
      email = rdata.data.qqemail;
      pagefooter = rdata.data.pagefooter;
    }
  } catch (error) {
    console.error(error);
  }
}
await getSetting();
export default {
  name,
  docsLink,
  homeLink,
  linkStr,
  footerLinkStr,
  requestLink,
  apibaseURL,
  configjson,
  configform,
  beian,
  downHost,
  paymode,
  qq,
  pagefooter,
  email,
}
</script>